import './Footer.css';

const Footer: React.FC = () => {
  return (
    <div className="footer">
      <div>© biiird games LLC, {new Date().getFullYear()}</div>
    </div>
  );
};

export default Footer;
